<ng-container *ngIf="!isSubmitted">
  <!-- file uploading -->

  <!-- Step1 -->
  <div *ngIf="(!fileList.length || fileList.length > 1) && !filename" class="d-flex">
    <div class="record record--small">
      <!-- <p class="record__title record__title--large mb-2"><strong>Already have a document?</strong></p> -->
      <p class="record__title record__title--large mb-4">Upload <span class="record__title--tag">PDF</span> <span
          class="record__title--tag">DOC</span> <span class="record__title--tag">DOCX</span> or <span
          class="record__title--tag">TXT</span> files only</p>
      <div appDnd (filesChangeEmiter)="onFilesChange($event)"
        [allowed_extensions]="['pdf', 'ppt', 'pptx', 'doc', 'docx', 'txt']"
        (filesInvalidEmiter)="filesInvalidEmiter($event)"
        class="record__block record__block--bordered position-relative  record__block--leftalign">
        <input (change)="onFilesChange($event.target.files)" accept=".doc, .docx,.ppt, .pptx,.txt,.pdf" type="file"
          class="droppable-file">
        <span class="record__block__circlebtn record__block__circlebtn--small">
          <i class="icon-file-upload"></i>
        </span>
        <span class="record__subtitle mg-b5">
          <!-- Drag and Drop your file here<br> or  -->
          <span class="record__uploadtitle record__uploadtitle--primary">Upload a file</span></span>
      </div>
    </div>
  </div>

  <!-- Step2 -->
  <div *ngIf="fileList.length == 1 || filename" class="QuestionBox">
    <div class="div-shadow">
      <div class="record position-relative">
        <a *ngIf="progress==100 || filename" href="javascript:void(0)" (click)="show()" class="record__close record__close--fileUpload"><i class="icon-delete-fill"></i></a>
        <p class="document-upload__title mb-4">Uploads:</p>
        <div *ngIf="showProgress" class="pd-t40 pd-b20">
          <div class="progress">
            <div class="progress-bar bg-success" [class.animated-progress]="progress!=100"
              [ngStyle]="{'width': progress+'%'}"></div>
          </div>
        </div>
        <div class="pd-t40 pd-b20 document-upload--controls">
          <p class="document-upload--fileinfo"><i class="me-2" [class.icon-file-txt]="extension == 'txt'"
              [class.icon-file-docx]="extension == 'docx' || extension == 'doc'"
              [class.icon-file-pdf]="extension =='pdf'"
              [class.icon-file-ppt]="extension =='ppt' || extension =='pptx'"></i>
            {{filename}}</p>
          <div *ngIf="showDeleteModal" class="delete-confirmation text-center">
            <div class="delete-confirmation__action">
              <a href="javascript:void(0)" (click)="hide()" class="btn btn-about btn-outline-primary min-width209 me-3"><span>Cancel</span></a>
              <a href="javascript:void(0)" (click)="delete()" class="btn btn-primary long-btn40 min-width209"><span>Yes, Delete</span></a>
            </div>
          </div>
          <div class="position-relative">
            <input (change)="onFilesChange($event.target.files)" type="file" class="droppable-file">
            <span class="record__uploadtitle">Replace File</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- file upload -->
  <div *ngIf="fileList.length > 1">
    <p class="error">Only One file can be selected.</p>
  </div>
</ng-container>
<ng-container *ngIf="isSubmitted">
  <div [class.notanswered]="!filename" class="record record--small pr-0">
    <div class="record__block record__block--bordered-solid d-block p-3" style="min-height: 0;">
      <div (click)="downloadFile()" *ngIf="filename" class="document-upload--controls cursor-pointer">
        <p class="document-upload--fileinfo"><i class="me-2" [class.icon-file-txt]="extension == 'txt'"
            [class.icon-file-docx]="extension == 'docx' || extension == 'doc'" [class.icon-file-pdf]="extension =='pdf'"
            [class.icon-file-ppt]="extension =='ppt' || extension =='pptx'"></i>
          {{filename}}</p>
      </div>
    </div>
  </div>
</ng-container>
